export enum ActivityTypeEnum {
  LOGIN = 'LOGIN',
  LOCATION_ADD = 'LOCATION_ADD',
  SYNC = 'SYNC',
  LEGAL_DOCUMENT_ACCEPTED = 'LEGAL_DOCUMENT_ACCEPTED',
  LEGAL_DOCUMENT_REJECTED = 'LEGAL_DOCUMENT_REJECTED',
  CLOSE_DATE = 'CLOSE_DATE',
  OPEN_DATE = 'OPEN_DATE',
  TIME_CARDS_CHANGE = 'TIME_CARDS_CHANGE',
  CHECKS_CHANGE = 'CHECKS_CHANGE',
  GRATSYNCUSER_GRANTACCESS = 'GRATSYNCUSER_GRANTACCESS',
  CALCULATED_DATA_CHANGE = 'CALCULATED_DATA_CHANGE',
  PAYROLL_EXPORT = 'PAYROLL_EXPORT',
  PAYROLL_UNLOCK = 'PAYROLL_UNLOCK',
  LOAD_CARD = 'LOAD_CARD',
  DAILY_TRANSACTIONS_CHANGE = 'DAILY_TRANSACTIONS_CHANGE',
  GRATSYNCUSER_REVOKEACCESS = 'GRATSYNCUSER_REVOKEACCESS',
  TEAM_UP = 'TEAM_UP',
  WIZARD_COMPANY_INFO = 'WIZARD_COMPANY_INFO',
  WIZARD_BUSINESS_LOCALIZATION = 'WIZARD_BUSINESS_LOCALIZATION',
  WIZARD_DATA_SOURCE = 'WIZARD_DATA_SOURCE',
  WIZARD_INSTALLATION = 'WIZARD_INSTALLATION',
  WIZARD_TIME_PROVIDER = 'WIZARD_TIME_PROVIDER',
  WIZARD_TENDERS_MAPPING = 'WIZARD_TENDERS_MAPPING',
  WIZARD_TRACKING_GROUPS = 'WIZARD_TRACKING_GROUPS',
  WIZARD_JOB_ELECTION = 'WIZARD_JOB_ELECTION',
  WIZARD_DISTRIBUTION = 'WIZARD_DISTRIBUTION',
  WIZARD_JOB_CONFIGURATION = 'WIZARD_JOB_CONFIGURATION',
  WIZARD_GLOBAL_CONFIGURATION = 'WIZARD_GLOBAL_CONFIGURATION',
  WIZARD_PAYMENT = 'WIZARD_PAYMENT',
  WIZARD_DATA_EXPORT = 'WIZARD_DATA_EXPORT',
  WIZARD_WORKFLOWS = 'WIZARD_WORKFLOWS',
  WIZARD_PRICING_AND_BILLING = 'WIZARD_PRICING_AND_BILLING',
  PAP_FUNCTION = 'PAP_FUNCTION',
  PAP_ALARMS = 'PAP_ALARMS',
  PAP_USER_MANUAL = 'PAP USER MANUAL',
  PAP_AUTO_TIME_CARD = 'PAP_AUTO_TIME_CARD',
  USER_CARD_ADD = 'USER_CARD_ADD',
  USER_CARD_REMOVE = 'USER_CARD_REMOVE',
  USER_CARD_UPDATE = 'USER_CARD_UPDATE',
  USER_CARD_CHANGE = 'USER_CARD_CHANGE',
  USER_LOAD_ENABLED = 'USER_LOAD_ENABLED',
  USER_CORPORATE_CARD_MEMBER_ID_UPDATED = 'USER_CORPORATE_CARD_MEMBER_ID_UPDATED',
  EMPLOYEE_INVITED = 'EMPLOYEE_INVITED',
  USER_SIGNED_UP = 'USER_SIGNED_UP',
  USER_AGE_VERIFIED = 'USER_AGE_VERIFIED',
  USER_BANK_ACCOUNT_SET = 'USER_BANK_ACCOUNT_SET',
  USER_BANK_ACCOUNT_REMOVE = 'USER_BANK_ACCOUNT_REMOVE',
  SET_TEMP_PASSWORD = 'SET_TEMP_PASSWORD',
  TEMP_PASSWORD_CHANGED = 'TEMP_PASSWORD_CHANGED',
  LOAD_CARD_RESOLVE = 'LOAD_CARD_RESOLVE',
  REOPEN_PAID_DATE = 'REOPEN_PAID_DATE',
  LOAD_CARD_SIMULATE = 'LOAD_CARD_SIMULATE'
}

export const ActivityTypeOptions = [
  { label: 'LOGIN', value: ActivityTypeEnum.LOGIN },
  { label: 'SYNC', value: ActivityTypeEnum.SYNC },
  { label: 'LOCATION ADD', value: ActivityTypeEnum.LOCATION_ADD },
  {
    label: 'LEGAL DOCUMENT ACCEPTED',
    value: ActivityTypeEnum.LEGAL_DOCUMENT_ACCEPTED,
  },
  {
    label: 'LEGAL DOCUMENT REJECTED',
    value: ActivityTypeEnum.LEGAL_DOCUMENT_REJECTED,
  },
  { label: 'CLOSE DATE', value: ActivityTypeEnum.CLOSE_DATE },
  { label: 'OPEN DATE', value: ActivityTypeEnum.OPEN_DATE },
  { label: 'REOPEN PAID DATE', value: ActivityTypeEnum.REOPEN_PAID_DATE },
  { label: 'LOAD CARD SIMULATE', value: ActivityTypeEnum.LOAD_CARD_SIMULATE },
  { label: 'TIME CARD CHANGE', value: ActivityTypeEnum.TIME_CARDS_CHANGE },
  {
    label: 'GRATSYNCUSER GRANT ACCESS',
    value: ActivityTypeEnum.GRATSYNCUSER_GRANTACCESS,
  },
  {
    label: 'CALCULATED DATA CHANGE',
    value: ActivityTypeEnum.CALCULATED_DATA_CHANGE,
  },
  { label: 'PAYROLL EXPORT', value: ActivityTypeEnum.PAYROLL_EXPORT },
  { label: 'PAYROLL UNLOCK', value: ActivityTypeEnum.PAYROLL_UNLOCK },
  { label: 'LOAD CARD', value: ActivityTypeEnum.LOAD_CARD },
  {
    label: 'DAILY TRANSACTIONS CHANGE',
    value: ActivityTypeEnum.DAILY_TRANSACTIONS_CHANGE,
  },
  { label: 'CHECKS CHANGE', value: ActivityTypeEnum.CHECKS_CHANGE },
  {
    label: 'GRATSYNCUSER REVOKE ACCESS',
    value: ActivityTypeEnum.GRATSYNCUSER_REVOKEACCESS,
  },
  {
    label: 'TEAM UP',
    value: ActivityTypeEnum.TEAM_UP,
  },
  { label: 'WIZARD COMPANY INFO', value: ActivityTypeEnum.WIZARD_COMPANY_INFO },
  {
    label: 'WIZARD BUSINESS LOCALIZATION',
    value: ActivityTypeEnum.WIZARD_BUSINESS_LOCALIZATION,
  },
  { label: 'WIZARD DATA SOURCE', value: ActivityTypeEnum.WIZARD_DATA_SOURCE },
  { label: 'WIZARD INSTALLATION', value: ActivityTypeEnum.WIZARD_INSTALLATION },
  {
    label: 'WIZARD TIME PROVIDER',
    value: ActivityTypeEnum.WIZARD_TIME_PROVIDER,
  },
  {
    label: 'WIZARD TENDERS MAPPING',
    value: ActivityTypeEnum.WIZARD_TENDERS_MAPPING,
  },
  {
    label: 'WIZARD TRACKING GROUPS',
    value: ActivityTypeEnum.WIZARD_TRACKING_GROUPS,
  },
  { label: 'WIZARD JOB ELECTION', value: ActivityTypeEnum.WIZARD_JOB_ELECTION },
  { label: 'WIZARD DISTRIBUTION', value: ActivityTypeEnum.WIZARD_DISTRIBUTION },
  {
    label: 'WIZARD JOB CONFIGURATION',
    value: ActivityTypeEnum.WIZARD_JOB_CONFIGURATION,
  },
  {
    label: 'WIZARD GLOBAL CONFIGURATION',
    value: ActivityTypeEnum.WIZARD_GLOBAL_CONFIGURATION,
  },
  { label: 'WIZARD PAYMENT', value: ActivityTypeEnum.WIZARD_PAYMENT },
  { label: 'WIZARD DATA EXPORT', value: ActivityTypeEnum.WIZARD_DATA_EXPORT },
  { label: 'WIZARD WORKFLOWS', value: ActivityTypeEnum.WIZARD_WORKFLOWS },
  {
    label: 'WIZARD PRICING AND BILLING',
    value: ActivityTypeEnum.WIZARD_PRICING_AND_BILLING,
  },
  {
    label: 'PAP FUNCTION',
    value: ActivityTypeEnum.PAP_FUNCTION,
  },
  {
    label: 'PAP ALARMS',
    value: ActivityTypeEnum.PAP_ALARMS,
  },
  {
    label: 'PAP USER MANUAL',
    value: ActivityTypeEnum.PAP_USER_MANUAL,
  },
  {
    label: 'PAP AUTO TIME CARD',
    value: ActivityTypeEnum.PAP_AUTO_TIME_CARD,
  },
  {
    label: 'USER CARD ADD',
    value: ActivityTypeEnum.USER_CARD_ADD,
  },
  {
    label: 'USER CARD REMOVE',
    value: ActivityTypeEnum.USER_CARD_REMOVE,
  },
  {
    label: 'USER CARD UPDATE',
    value: ActivityTypeEnum.USER_CARD_UPDATE,
  },
  {
    label: 'USER CARD CHANGE',
    value: ActivityTypeEnum.USER_CARD_CHANGE,
  },
  {
    label: 'USER LOAD ENABLED',
    value: ActivityTypeEnum.USER_LOAD_ENABLED,
  },
  {
    label: 'USER CORPORATE CARD MEMBER ID UPDATED',
    value: ActivityTypeEnum.USER_CORPORATE_CARD_MEMBER_ID_UPDATED,
  },
  {
    label: 'EMPLOYEE INVITED',
    value: ActivityTypeEnum.EMPLOYEE_INVITED,
  },
  {
    label: 'USER SIGNED UP',
    value: ActivityTypeEnum.USER_SIGNED_UP,
  },
  {
    label: 'USER AGE VERIFIED',
    value: ActivityTypeEnum.USER_AGE_VERIFIED,
  },
  {
    label: 'USER BANK ACCOUNT SET',
    value: ActivityTypeEnum.USER_BANK_ACCOUNT_SET,
  },
  {
    label: 'USER BANK ACCOUNT REMOVE',
    value: ActivityTypeEnum.USER_BANK_ACCOUNT_REMOVE,
  },
  {
    label: 'SET TEMP PASSWORD',
    value: ActivityTypeEnum.SET_TEMP_PASSWORD,
  },
  {
    label: 'TEMP PASSWORD CHANGED',
    value: ActivityTypeEnum.TEMP_PASSWORD_CHANGED,
  },
  {
    label: 'LOAD CARD RESOLVE',
    value: ActivityTypeEnum.LOAD_CARD_RESOLVE,
  }
].sort((a, b) => a.label.localeCompare(b.label));
